/*
 * Cart count sync
 * Watches cart requests (fetch + XHR) site-wide and updates .cart-count-cls
 */
(function () {
  if (window.__cartPatched) return;
  window.__cartPatched = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var COUNT_SELECTOR = '.cart-count-cls';
  var MUTATION_URL = /\/cart\/(add|change|update|clear)/;
  var ADD_URL = /\/cart\/add/;
  var origFetch = window.fetch.bind(window);
  var inFlight = null; // current background refresh

  function getDrawer() {
    return (
      document.getElementById('cart-drawer') ||
      document.querySelector('cart-drawer-component')
    );
  }

  function updateCount(count) {
    document.querySelectorAll(COUNT_SELECTOR).forEach(function (el) {
      el.textContent = count;
    });
  }

  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer || drawer.isOpen) return;
    if (typeof drawer.open === 'function') drawer.open();
    else if (typeof drawer.showDialog === 'function') drawer.showDialog();
  }

  // Background refresh: drawer HTML + count
  function refresh() {
    var p = Promise.all([
      origFetch(root + '?sections=cart-drawer-section').then(function (r) { return r.json(); }),
      origFetch(root + 'cart.js').then(function (r) { return r.json(); })
    ])
      .then(function (res) {
        var html = res[0]['cart-drawer-section'];
        var cart = res[1];
        var drawer = getDrawer();

        // Don't swap while open - Horizon updates the open drawer itself
        if (html && !(drawer && drawer.isOpen)) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('cart-drawer-component');
          var current = document.querySelector('cart-drawer-component');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        }

        updateCount(cart.item_count);
      })
      .catch(function (err) {
        console.error('Cart refresh failed:', err);
      })
      .finally(function () {
        if (inFlight === p) inFlight = null;
      });

    inFlight = p;
    return p;
  }

  function onCartMutation(url) {
    if (ADD_URL.test(url)) {
      // small delay so free gifts from app/discount land too
      setTimeout(function () {
        refresh().then(openDrawer);
      }, 300);
    } else {
      refresh();
    }
  }

  // Patch fetch
  window.fetch = function (input) {
    var url = input instanceof Request ? input.url : String(input);
    var promise = origFetch.apply(window, arguments);
    if (!MUTATION_URL.test(url)) return promise;

    return promise.then(function (res) {
      if (res.ok) onCartMutation(url);
      return res;
    });
  };

  // Patch XHR (jQuery / older apps)
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    var u = String(url);
    if (MUTATION_URL.test(u)) {
      this.addEventListener('load', function () {
        if (this.status < 400) onCartMutation(u);
      });
    }
    return origOpen.apply(this, arguments);
  };

  // Header cart icon: open instantly
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cart-drawer-trigger]');
    if (!trigger || !getDrawer()) return; // no drawer → normal /cart link
    e.preventDefault();

    // only wait if a refresh is literally mid-flight (e.g. just added to cart)
    if (inFlight) inFlight.then(openDrawer);
    else openDrawer();
  });

  function cleanCartVariants() {
    document.querySelectorAll('.cart-items__variants').forEach((container) => {
      const firstValue = container.querySelector(
        '.cart-items__variant:first-child dd'
      );

      if (!firstValue) return;

      const cleanedHTML = firstValue.innerHTML
        .replace(/,\s*(&nbsp;)?\s*$/i, '')
        .trim();

      // Update only when necessary to avoid repeated DOM mutations
      if (firstValue.innerHTML !== cleanedHTML) {
        firstValue.innerHTML = cleanedHTML;
      }
    });
  }

    // Overlay: toggle .active on .cstm_ovrly while the drawer is open
  function syncOverlay() {
    var overlay = document.querySelector('.cstm_ovrly');
    var drawer = getDrawer();
    if (!overlay || !drawer) return;
    var isOpen = !!(drawer.isOpen || drawer.querySelector('dialog[open]'));
    overlay.classList.toggle('active', isOpen);
  }

  // function watchDrawer() {
  //   var drawer = getDrawer();
  //   if (!drawer) return;
  //   new MutationObserver(syncOverlay).observe(drawer, {
  //     attributes: true,
  //     attributeFilter: ['open'],
  //     subtree: true,
  //     childList: true
  //   });
  //   syncOverlay();
  //   cleanCartVariants();
  // }

  function watchDrawer() {
    const drawer = getDrawer();
    if (!drawer) return;

    const observer = new MutationObserver(() => {
      syncOverlay();
      cleanCartVariants();
    });

    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['open'],
      subtree: true,
      childList: true
    });

    syncOverlay();
    cleanCartVariants();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawer);
  } else {
    watchDrawer();
  }

  window.refreshCartDrawer = refresh;
  window.openCartDrawer = openDrawer;
})();


/*
 * Gummify Buy Box
 */
document.addEventListener('DOMContentLoaded', function () {

  const adultButtonsWrapper = document.getElementById('adultButtons');
  const adultVariantGroups = document.getElementById('adultVariantGroups');
  if (!adultButtonsWrapper || !adultVariantGroups) return;

  const adultButtons = adultButtonsWrapper.querySelectorAll('[id^="adultBtn-"]');
  const adultGroups = adultVariantGroups.querySelectorAll('[id^="adultGroup-"]');
  const allItems = adultVariantGroups.querySelectorAll('.order_gift_inr_item');
  if (!adultButtons.length || !adultGroups.length) return;

  const subscribeCheck = document.querySelector('.subscribe_check');
  const subscribeWrap = document.querySelector('.subscribe_wrap');
  const subscribeBtn = document.querySelector('.subscribe_wrap');
  const subPriceEl = document.querySelector('.subscribe_wrap .sub_price');
  const subCompareEl = document.querySelector('.subscribe_wrap .sub_compare');
  const subDiscountEls = document.querySelectorAll('.subscribe_wrap .sub_discnt');
  const subLabelEl = document.querySelector('.subscribe_wrap .sub_label');

  // Two gift sections: one-time (variant) and subscription
  const giftWrap = document.getElementById('giftItems');
  const subGiftWrap = document.getElementById('subGiftItems');
  const variantGiftSection = document.querySelector('.your_gift.variant_gifts');
  const subGiftSection = document.querySelector('.your_gift.subscribe_gifts');

  const addToCartBtn = document.querySelector('.add_to_Cart_btn .primary-btn');
  const root = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';

  let selectedVariantId = null;
  let lastActiveIndex = 0; // offer position (0 = first) kept across adult switches
  let selectedPrice = '';
  let selectedQty = 1;
  const baseVariantId = adultVariantGroups.dataset.baseVariant || '';
  const atcPriceEl = addToCartBtn ? addToCartBtn.querySelector('.atc_price') : null;

  function updateAtcPrice() {
    if (!atcPriceEl) return;
    const price = isSubscribed() ? (subscribeCheck.dataset.price || '') : selectedPrice;
    atcPriceEl.textContent = price ? '– ' + price : '';
  }

  /*
   * Gifts
   * One-time section: free gifts first (metafield order), then crossed ones.
   * Subscription section: only milestone gifts, earliest month first.
   */
  function updateGifts(source, wrap) {
    wrap = wrap || giftWrap;
    if (!source || !wrap) return;

    const isSubWrap = wrap === subGiftWrap;

    const available = (source.dataset.gifts || '')
      .split(',')
      .map(h => h.trim())
      .filter(Boolean);

    // id::note::month||
    const notes = {};
    const months = {};
    (source.dataset.notes || '').split('||').forEach(function (pair) {
      const parts = pair.split('::');
      const id = (parts[0] || '').trim();
      if (!id) return;
      if (parts[1]) notes[id] = parts[1].trim();
      months[id] = Number(parts[2]) || 0;
    });

    const items = Array.prototype.slice.call(wrap.querySelectorAll('.gift_item'));

    items.forEach(function (gift, i) {
      if (gift.dataset.origIndex === undefined) gift.dataset.origIndex = i;

      const handle = gift.dataset.giftHandle;
      const isFree = available.includes(handle);
      const box = gift.querySelector('.gift_box');
      const freeLabel = gift.querySelector('.gift_free');
      const cross = gift.querySelector('.gift_cross');
      const noteEl = gift.querySelector('.sub-gift-note');

      gift.dataset.free = isFree ? 'true' : 'false';
      if (box) box.classList.toggle('gift_not_avail', !isFree);
      if (freeLabel) freeLabel.style.display = isFree ? '' : 'none';
      if (cross) cross.style.display = isFree ? 'none' : '';

      if (noteEl) {
        const note = notes[handle] || '';
        noteEl.textContent = note;
        noteEl.style.display = note ? 'block' : 'none';
      }

      // Subscription section: only show the milestone gifts
      if (isSubWrap) gift.style.display = isFree ? '' : 'none';
    });

    items
      .sort(function (a, b) {
        const ah = a.dataset.giftHandle;
        const bh = b.dataset.giftHandle;
        const ai = available.indexOf(ah);
        const bi = available.indexOf(bh);

        if (ai !== -1 && bi !== -1) {
          // Subscription: earliest month first
          if (isSubWrap && months[ah] !== months[bh]) return months[ah] - months[bh];
          return ai - bi;
        }
        if (ai !== -1) return -1;
        if (bi !== -1) return 1;
        return Number(a.dataset.origIndex) - Number(b.dataset.origIndex);
      })
      .forEach(g => wrap.appendChild(g));
  }

  // Free gift variant IDs from the one-time section, in display order
  function getFreeGiftVariantIds() {
    if (!giftWrap) return [];
    return Array.prototype.filter.call(giftWrap.querySelectorAll('.gift_item'), g => g.dataset.free === 'true')
      .map(g => g.dataset.giftVariant)
      .filter(Boolean);
  }

  function showGiftSection(subscribed) {
    if (variantGiftSection) variantGiftSection.style.display = subscribed ? 'none' : 'block';
    if (subGiftSection) subGiftSection.style.display = subscribed ? 'block' : 'none';
  }

  /*
   * Selection
   */
  function getItems(group) {
    return group.querySelectorAll('.order_gift_inr_item');
  }

  function setSelected(item) {
    selectedVariantId = item.dataset.variantId || null;
    selectedPrice = item.dataset.price || '';
    selectedQty = Number(item.dataset.qty) || 1;

    const group = item.closest('.adult_variant_group');
    if (group) {
      const index = Array.prototype.indexOf.call(getItems(group), item);
      if (index !== -1) lastActiveIndex = index;
    }

    updateGifts(item, giftWrap);
    updateAtcPrice();
  }

  function selectItem(group, item) {
    getItems(group).forEach(i => i.classList.remove('active'));
    item.classList.add('active');
    setSelected(item);
  }

  // Select the offer at the same position; fall back to the last one if this group has fewer
  function selectAtIndex(group, index) {
    const items = getItems(group);
    if (!items.length) return;
    selectItem(group, items[index] || items[items.length - 1]);
  }

  // Always keep the same offer position across adult groups
  function selectForGroup(group) {
    selectAtIndex(group, lastActiveIndex);
  }

  function getVisibleGroup() {
    return Array.prototype.find.call(adultGroups, g => g.style.display !== 'none') || adultGroups[0];
  }

  /*
   * Subscription
   */
  function isSubscribed() {
    return !!(subscribeCheck && subscribeCheck.checked);
  }

  // Copy the visible adult group's subscription data into the subscribe box
  function applySubFromGroup(group) {
    if (!subscribeCheck || !subscribeWrap) return;

    document.querySelectorAll('.sub_gifts_set').forEach(function (set) {
      set.style.display = set.dataset.adultGroup === group.id ? '' : 'none';
    });

    const d = group.dataset;
    const hasSub = !!(d.subVariant && d.subPlan);

    subscribeWrap.style.display = hasSub ? '' : 'none';

    if (!hasSub) {
      if (isSubscribed()) {
        disableSubscription();
        selectForGroup(group);
      }
      return;
    }

    subscribeCheck.dataset.variantId = d.subVariant;
    subscribeCheck.dataset.sellingPlan = d.subPlan;
    subscribeCheck.dataset.gifts = d.subGifts || '';
    subscribeCheck.dataset.notes = d.subNotes || '';
    subscribeCheck.dataset.price = d.subPrice || '';
    subscribeCheck.dataset.qty = d.subQty || '1';
    subscribeCheck.dataset.baseOk = d.subBaseOk || 'false';
    subscribeCheck.dataset.giftsNow = d.subGiftsNow || '';

    if (subPriceEl) subPriceEl.textContent = d.subPrice || '';
    if (subCompareEl) {
      subCompareEl.textContent = d.subCompare || '';
      subCompareEl.style.display = d.subCompare ? '' : 'none';
    }
    subDiscountEls.forEach(function (el) {
      el.textContent = d.subDiscount ? d.subDiscount + '% OFF' : '';
      el.style.display = d.subDiscount ? '' : 'none';
    });
    if (subLabelEl && d.subLabel) subLabelEl.textContent = d.subLabel;
  }

  function enableSubscription() {
    allItems.forEach(function (i) {
      i.classList.remove('active');
      i.classList.add('disabled');
    });
    if (subscribeWrap) subscribeWrap.classList.add('active', 'sub-gifts-active');
    showGiftSection(true);
    updateAtcPrice();
  }

  function disableSubscription() {
    if (subscribeCheck) subscribeCheck.checked = false;
    if (subscribeWrap) subscribeWrap.classList.remove('active', 'sub-gifts-active');
    allItems.forEach(i => i.classList.remove('disabled'));
    showGiftSection(false);
    updateAtcPrice();
  }

  if (subscribeCheck) {
    subscribeCheck.addEventListener('change', function () {
      if (subscribeCheck.checked) {
        enableSubscription();
        return;
      }

      disableSubscription();

      // Restore the same offer position in the visible group
      selectForGroup(getVisibleGroup());
    });

    if (subscribeBtn) {
      subscribeBtn.addEventListener('click', function (event) {
        // Let the checkbox/label handle their own clicks; ignore clicks on the gifts
        if (event.target.closest('.subscribe-option, .subscribe_gifts')) return;

        subscribeCheck.checked = !subscribeCheck.checked;
        subscribeCheck.dispatchEvent(new Event('change'));
      });
    }
  }

  /*
   * Pouch clicks (event delegation, one listener)
   */
  adultVariantGroups.addEventListener('click', function (event) {
    const item = event.target.closest('.order_gift_inr_item');
    if (!item) return;

    // Clicking a pouch while subscribed switches back to one-time
    if (isSubscribed()) disableSubscription();

    const group = item.closest('.adult_variant_group');
    if (!group) return;

    group.dataset.pickedVariant = item.dataset.variantId;
    selectItem(group, item);
  });

  /*
   * Adult button clicks
   * Keeps the same offer position (e.g. middle stays middle)
   */
  adultButtonsWrapper.addEventListener('click', function (event) {
    const button = event.target.closest('[id^="adultBtn-"]');
    if (!button) return;

    event.preventDefault();

    const targetGroup = document.getElementById(button.dataset.target || '');
    if (!targetGroup) return;

    adultButtons.forEach(b => b.classList.remove('active'));
    button.classList.add('active');

    adultGroups.forEach(g => { g.style.display = g === targetGroup ? 'block' : 'none'; });

    applySubFromGroup(targetGroup);

    if (isSubscribed()) {
      // Stay subscribed: switch to this adult's plan
      enableSubscription();
    } else {
      selectForGroup(targetGroup);
    }
  });

  /*
   * Initial state
   */
  showGiftSection(false);
  applySubFromGroup(adultGroups[0]);
  const initialActive = adultGroups[0].querySelector('.order_gift_inr_item.active');
  const initialIndex = initialActive ? Array.prototype.indexOf.call(getItems(adultGroups[0]), initialActive) : 0;
  selectAtIndex(adultGroups[0], initialIndex);
  // Treat the default selection as this group's pick
  const defaultItem = adultGroups[0].querySelector('.order_gift_inr_item.active');
  if (defaultItem) adultGroups[0].dataset.pickedVariant = defaultItem.dataset.variantId;

  /*
   * Add to cart
   */
  if (!addToCartBtn) return;

  const atcTextEl = addToCartBtn.querySelector('.atc_text') || addToCartBtn;
  const originalLabel = atcTextEl.textContent;
  let isAdding = false;

  function resetButton() {
    atcTextEl.textContent = originalLabel;
    addToCartBtn.classList.remove('is-loading');
    isAdding = false;
  }

  function getMainItem() {
    if (isSubscribed()) {
      const plan = (subscribeCheck.dataset.sellingPlan || '').split('/').pop();
      if (!plan) throw new Error('Subscription is not set up for this product.');

      // Subscription: base pouch (1 Adult / 1 Pouch) x pouch count of the selected plan
      if (baseVariantId && subscribeCheck.dataset.baseOk === 'true') {
        return {
          id: Number(baseVariantId),
          quantity: Number(subscribeCheck.dataset.qty) || 1,
          selling_plan: Number(plan)
        };
      }

      // Fallback if no base variant was found: old behaviour
      const id = subscribeCheck.dataset.variantId;
      if (!id) throw new Error('Subscription is not set up for this product.');
      return { id: Number(id), quantity: 1, selling_plan: Number(plan) };
    }

    if (!selectedVariantId) throw new Error('Please select a pack first.');

    // One-time: add the base pouch SKU x pouch count, so inventory drops by the real number of pouches
    if (baseVariantId) return { id: Number(baseVariantId), quantity: selectedQty };

    // Fallback if no base variant was found: old behaviour
    return { id: Number(selectedVariantId), quantity: 1 };
  }

  addToCartBtn.addEventListener('click', function (event) {
    event.preventDefault();
    if (isAdding) return;

    let mainItem;
    try {
      mainItem = getMainItem();
    } catch (error) {
      alert(error.message);
      return;
    }

    // One-time: the selected offer's free gifts. Subscription: only the immediate (month 0/1) milestone gifts
    const giftVariantIds = isSubscribed()
      ? (subscribeCheck.dataset.giftsNow || '').split(',').map(id => id.trim()).filter(Boolean)
      : getFreeGiftVariantIds();

    isAdding = true;
    atcTextEl.textContent = 'Adding...';
    addToCartBtn.classList.add('is-loading');

    // Only check the cart when there are gifts to dedupe
    const cartCheck = giftVariantIds.length
      ? fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json())
      : Promise.resolve({ items: [] });

    cartCheck
      .then(function (cart) {
        const giftsInCart = cart.items
          .filter(i => i.properties && i.properties._gift)
          .map(i => String(i.variant_id));

        const giftItems = giftVariantIds
          .filter(id => !giftsInCart.includes(String(id)))
          .map(id => ({ id: Number(id), quantity: 1, properties: { _gift: 'Free gift' } }));

        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          // Shopify lists the last item of a batch first, so gifts go before the main item
          body: JSON.stringify({ items: giftItems.concat([mainItem]) })
        });
      })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
          return data;
        });
      })
      .then(function () {
        // Cart count + drawer are handled by the cart sync above
        atcTextEl.textContent = 'Added!';
        setTimeout(resetButton, 1500);
      })
      .catch(function (error) {
        alert(error.message);
        resetButton();
      });
  });
});